import React from 'react';
import { OrganizationsTableContainer } from '@/components/Organization/OrganizationsTable/OrganizationsTableContainer';
import { PageTitle } from '@/components/common/PageTitle/PageTitle';
import { RouteContentWrapper } from '../../styles';

export const AdminOrganizationsRoute = () => {
    return (
        <RouteContentWrapper>
            <PageTitle title="Organizations" />
            <OrganizationsTableContainer />
        </RouteContentWrapper>
    );
};
